import { render, staticRenderFns } from "./FullIngredientsList.vue?vue&type=template&id=4770f7d4&scoped=true&"
import script from "./FullIngredientsList.vue?vue&type=script&lang=js&"
export * from "./FullIngredientsList.vue?vue&type=script&lang=js&"
import style0 from "./FullIngredientsList.vue?vue&type=style&index=0&id=4770f7d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4770f7d4",
  null
  
)

export default component.exports